// Theme by default loads a jQuery as dependency of the main script.
// Let's include it using ES6 modules import.
import $ from 'jquery'


function calculateForm4(){

  var stuwdruk = $('.acf-field').find("[data-name='form4_stuwdruk']").find(':input').val();
  var zone = $('.acf-field').find("[data-name='form4_zone']").find('label.selected > input[type="radio"]').val();
  var ankers_hoh = $('.acf-field').find("[data-name='form4_anker_hoh']").find(':input').val();
  var hoogte_element = $('.acf-field').find("[data-name='form4_hoogte']").find(':input').val();
  var kwaliteit = $('.acf-field').find("[data-name='form4_kwaliteit']").find('label.selected > input[type="radio"]').val();

  var anker_hoogteA = $('.acf-field').find("[data-name='form4_hoogteA']").find(':input').val();
  var anker_voetC = $('.acf-field').find("[data-name='form4_voetC']").find(':input').val();
  var afstand_beton_anker = $('.acf-field').find("[data-name='form4_afstand_tot_anker']").find(':input').val();
  var afstand_hout_beton = $('.acf-field').find("[data-name='form4_ruimte_hout']").find(':input').val();
  var breedte_anker = $('.acf-field').find("[data-name='form4_breedte']").find(':input').val();
  var gekozen_dikte = $('.acf-field').find("[data-name='form4_dikte']").find(':input').val();
  var staal_kwaliteit = $('.acf-field').find("[data-name='form4_staalkwaliteit']").find('label.selected > input[type="radio"]').val();

  $.ajax({
    url: '/wp-admin/admin-ajax.php',
    data: {
      action: 'form4Calculate',
      stuwdruk: stuwdruk,
      zone: zone,
      ankers_hoh: ankers_hoh,
      hoogte_element: hoogte_element,
      kwaliteit: kwaliteit,
      anker_hoogteA: anker_hoogteA,
      anker_voetC: anker_voetC,
      afstand_beton_anker: afstand_beton_anker,
      afstand_hout_beton: afstand_hout_beton,
      breedte_anker: breedte_anker,
      gekozen_dikte: gekozen_dikte,
      staal_kwaliteit: staal_kwaliteit
    },
    method: 'POST',
    success: function (html) {
      $('.calculation-result').html(html);
      $('#form4Calc .acf-form-submit input[type="submit"]').prop("disabled", false).addClass('active');
    }
  });

}

$(document).ready(function(){

  $('#form4Calc .acf-form-submit input[type="submit"]').prop("disabled", true);
  $('#form4Calc .acf-form-submit').append('<input type="submit" id="calculate_form4" value="Berekenen" class="calculate-btn btn btn--primary"/>');

  $('#calculate_form4').click(function(e){
    e.preventDefault();
    calculateForm4();
  });

});



// WEBPACK FOOTER //
// ./resources/assets/js/form4.js